import React, { Component } from 'react';
import { Route } from 'react-router';
import { Layout } from './components/Layout';
import Home from './components/Home';
import { FetchData } from './components/FetchData';
import { Counter } from './components/Counter';
import { Branches } from './components/Branches';
import Display from './components/Display';
import DisplayNotice from './components/DisplayNotice';
import BeginnerSignUp from './components/BeginnerSignUp';
import OccupySeat from './components/OccupySeat';
import ReserveSeat from './components/ReserveSeat';
import ReserveRoom from './components/ReserveRoom';
import Copyright from './components/Copyright'
import SignIn from './components/SignIn'
import SignUp from './components/SignUp'
import MoveSeat from './components/seat/MoveSeat'
import ExtendSeat from './components/seat/ExtendSeat'
import Monthly from './components/Monthly'
import Prepaid from './components/Prepaid'
import FixedSeat from './components/FixedSeat'
import SnackMenu from './components/SnackMenu'
import Showcase1 from './components/snack/Showcase1'
import Showcase2 from './components/snack/Showcase2'
import CabinetUse from './components/CabinetUse'
import CabinetUseExtend from './components/CabinetUseExtend'
import PaymentComplete from './components/payment/Complete'
import ChargeMoney from './components/ChargeMoney'
import History from './components/History'
import FindIdPw from './components/FindIdPw'
import SmsAgreement from './components/SmsAgreement'
import ChangeJWT from './components/ChangeJWT'
import RoomManager from './components/RoomManager'
import SeatChart from './components/SeatChart'
import PrinterUse from './components/PrinterUse'





export default class App extends Component {
    static displayName = App.name;

    render() {
        return (
            <Layout>
                <Route exact path='/' component={Home} />
                <Route path='/counter' component={Counter} />
                <Route path='/fetch-data' component={FetchData} />
                <Route path='/branches' component={Branches} />
                <Route path='/display/:charging' component={Display} />
                <Route path='/displayNotice/:message' component={DisplayNotice} />
                <Route path='/beginnerSignUp' component={BeginnerSignUp} />
                <Route path='/occupySeat' component={OccupySeat} />
                <Route path='/reserveSeat' component={ReserveSeat} />
                <Route path='/reserveRoom' component={ReserveRoom} />
                <Route path='/signIn' component={SignIn} />
                <Route path='/signUp' component={SignUp} />
                <Route path='/moveSeat/:reservationId' component={MoveSeat} />
                <Route path='/extendSeat/:reservationId' component={ExtendSeat} />
                <Route path='/monthly' component={Monthly} />
                <Route path='/prepaid' component={Prepaid} />
                <Route path='/fixedSeat' component={FixedSeat} />
                <Route path='/snackMenu' component={SnackMenu} />
                <Route path='/showcase1' component={Showcase1} />
                <Route path='/showcase2' component={Showcase2} />
                <Route path='/cabinetUse' component={CabinetUse} />
                <Route path='/cabinetUseExtend/:cabinetUseId' component={CabinetUseExtend} />
                <Route path='/paymentComplete' component={PaymentComplete} />
                <Route path='/chargeMoney' component={ChargeMoney} />
                <Route path='/history' component={History} />
                <Route path='/findIdPw' component={FindIdPw} />
                <Route path='/smsAgreement' component={SmsAgreement} />
                <Route path='/change/:jwt' component={ChangeJWT} />
                <Route path='/roomManager/:uuid' component={RoomManager} />
                <Route path='/seatChart' component={SeatChart} />
                <Route path='/printerUse' component={PrinterUse} />
                
                
            </Layout>
        );
    }
}



// WEBPACK FOOTER //
// ./src/App.js